/*
 * Stable unique ids for aria wiring. Vue's own useId() lands in 3.5; this
 * project is on 3.4.
 */
let counter = 0;

export function nextUid(prefix = 'dx') {
    counter += 1;
    return `${prefix}-${counter}`;
}
